app.controller("AreaApartmentListController",
	["$scope", "$timeout", "ApartmentSearchModel", "ApartmentSearchService", function($scope, $timeout, ApartmentSearchModel, ApartmentSearchService) {

		$scope.postCodes = [];
		$scope.searchID = undefined;
		$scope.query = ApartmentSearchService.CreateQuery();
		$scope.searchResults = ApartmentSearchModel.results;


		function createAddressConstraint(postCode) {
			return function() {
				return {
					query: {
						postcode: postCode
					}
				};
			};
		}

		$scope.Init = function(postCodes, searchID) {

			$scope.searchID = searchID;
			$scope.postCodes = postCodes;

			for(var i = 0; i < $scope.postCodes.length; i++) {
				var addressConstraint = createAddressConstraint(postCodes[i]);
				$scope.query.AddAddressConstraint(addressConstraint());
			}

			ApartmentSearchService.RunQuery($scope.query, $scope.searchID, false);
		};

		$scope.LoadMore = function() {
			$scope.query.SetSkip($scope.query.GetSkip() + $scope.query.GetResultLimit());
			ApartmentSearchService.RunQuery($scope.query, $scope.searchID, true);
		};


	}]
);